import React from "react";
import { AvForm } from "availity-reactstrap-validation";
import { Spinner } from "reactstrap";

import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import { CustomCardBody } from "@components/Common/CustomCardStyled";

import "./index.css";
import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";

import { useMoneticsApplicationForm } from "./useMoneticsApplicationForm";
import { MoneticsFormProvider } from "./MoneticsFormContext";
import { MoneticConfigSwitch } from "./MoneticConfigSwitch";
import { MoneticFormHeader } from "./components/MoneticFormHeader";
import { DesignationField } from "./components/DesignationField";
import { MarkSelectField } from "./components/MarkSelectField";
import { RemarkField } from "./components/RemarkField";
import { MoneticFormFooter } from "./components/MoneticFormFooter";
import { MoneticsFormProps } from "./types";

const MONETICS_PERIPHERALS_PATHNAME = "/peripherals/monetics";
const PERIPHERALS_BODY_MAX_HEIGHT = "500px";
const ASSOCIATE_BODY_MAX_HEIGHT = "522px";

export default function MoneticsApplicationForm(props: MoneticsFormProps) {
    const form = useMoneticsApplicationForm(props);

    const contextValue = React.useMemo(
        () => ({ form, props }),
        [form, props]
    );

    const bodyMaxHeight =
        form.pathname === MONETICS_PERIPHERALS_PATHNAME
            ? PERIPHERALS_BODY_MAX_HEIGHT
            : ASSOCIATE_BODY_MAX_HEIGHT;

    return (
        <MoneticsFormProvider value={contextValue}>
            <AvForm className="card">
                <MoneticFormHeader />
                <CustomCardBody
                    className="pl-3 pr-5"
                    style={{ maxHeight: bodyMaxHeight, overflowY: " scroll" }}
                >
                    <DesignationField />
                    <MarkSelectField />
                    <MoneticConfigSwitch />
                    <RemarkField />
                </CustomCardBody>
                <MoneticFormFooter />
            </AvForm>
            <ConfirmationEditMessage
                isModalOpened={form.isModalOpened}
                setIsModalOpened={form.setIsModalOpened}
                setIsAddClicked={props.setIsAddMoneticsClicked}
                setEditedData={props.setEditedData}
            />
            {form.isDisabled ? (
                <Spinner
                    style={{
                        position: "absolute",
                        top: "55%",
                        left: "83%",
                        color: "gray",
                    }}
                />
            ) : null}
        </MoneticsFormProvider>
    );
}
